import { customerTypes } from '@/modules/base/util/constants'

const buildName = (user) => {
  if (!user) { return '' }

  const { kind, name, firstName, lastName, email, invitationEmail } = user
  if (kind === customerTypes.COMPANY) {
    return name
  }

  return (firstName || lastName)
    ? `${firstName} ${lastName}`
    : name || email || invitationEmail
}

export default buildName
